<app-health-center-page
	[bundle]="bundle$ | async"
	[healthCenterResp]="healthCenterProtocolsResp$ | async"
	[sailing]="reservationRetrievalResponse$ | async"
	[brandName]="brandName"
	[urlPrefix]="urlPrefix"
></app-health-center-page>
